import { Component, OnInit } from '@angular/core';
import {FormGroup } from '@angular/forms';
import { apiService } from '../../../../../service/api.service'
import Swal from 'sweetalert2';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef} from '@angular/material/dialog';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';

@Component({
  selector: 'app-modal-recuperar-password',
  templateUrl: './modal-recuperar-password.component.html',
  styleUrls: ['./modal-recuperar-password.component.css']
})
export class ModalRecuperarPasswordComponent implements OnInit {

  form: FormGroup;
  rbdForm:number;
  respuesta: string;
   spinnerRef:any;

  constructor(private api: apiService,
    private formBuilder: FormBuilder,    
    public dialogRef: MatDialogRef<ModalRecuperarPasswordComponent> ,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      rbd: ''
    });
  }

  confirmar(){
    this.rbdForm=parseInt(this.form.value.rbd);
    this.spinnerRef = this.spinnerService.start();
    this.api.API_GET_recuperarPassword(this.rbdForm).subscribe((response: any) => {
       this.respuesta = response.payload;  
       let respuestas: string[] =this.respuesta.split("-");

       if(respuestas[0] === "1"){
          Swal.fire({
            title: 'Correo',
            text: respuestas[1],
            icon: "success",
            confirmButtonText: 'OK'
          });
       }else{
          Swal.fire({
              title: 'Error',
              text: respuestas[1],
              icon: 'error',
              confirmButtonText: 'OK'
            })
       }
       this.spinnerService.stop(this.spinnerRef);
      this.dialogRef.close();  
          
    },
    (err) => {
            Swal.fire({
              title: 'Error!',
              text: 'Error al enviar contraseña',
              icon: 'error',
              confirmButtonText: 'OK'
            })
            this.dialogRef.close();  
    });  
    
  }

}
